import FullScreenLoader from '@/core/components/FullScreenLoader/FullScreenLoader';

export default FullScreenLoader;
